import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14.6669 4.66641L8.68693 8.46641C8.48111 8.59536 8.24314 8.66375 8.00026 8.66375C7.75738 8.66375 7.51941 8.59536 7.31359 8.46641L1.33359 4.66641M2.66693 2.66641H13.3336C14.07 2.66641 14.6669 3.26336 14.6669 3.99974V11.9997C14.6669 12.7361 14.07 13.3331 13.3336 13.3331H2.66693C1.93055 13.3331 1.33359 12.7361 1.33359 11.9997V3.99974C1.33359 3.26336 1.93055 2.66641 2.66693 2.66641Z",
      stroke: "currentColor",
      "stroke-width": "1.3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }